<div class="flex flex-col bg-white rounded-xl shadow-2xl w-[680px] max-h-[80vh]">
  <!-- Header -->
  <div class="flex items-start justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0">
    <div>
      <h2 class="text-lg font-semibold text-momentum-deep_purple">{{ data.title }}</h2>
      @if (data.subtitle) {
        <p class="text-sm text-agentium_gray-text mt-1">{{ data.subtitle }}</p>
      }
    </div>
    <button
      type="button"
      class="ml-4 text-gray-400 hover:text-gray-600 flex-shrink-0 mt-0.5"
      (click)="close()"
      aria-label="Close"
    >
      <fa-icon [icon]="faXmark" size="lg"></fa-icon>
    </button>
  </div>

  <!-- Scrollable Body -->
  <div class="overflow-y-auto px-6 py-5 space-y-6">
    @for (section of data.sections; track $index) {
      <div>
        @if (section.heading) {
          <h3 class="text-sm font-semibold text-momentum-deep_purple uppercase tracking-wide mb-3">
            {{ section.heading }}
          </h3>
        }
        <div class="space-y-3">
          @for (item of section.items; track item.label) {
            <div>
              <p class="text-sm font-semibold text-gray-800">{{ item.label }}</p>
              <p class="text-sm text-agentium_gray-text mt-0.5" [innerHTML]="item.description"></p>
              @if (item.bullets && item.bullets.length > 0) {
                <ul class="mt-1.5 ml-4 list-disc space-y-1">
                  @for (bullet of item.bullets; track $index) {
                    @if (isIconBullet(bullet)) {
                      <li class="text-sm text-agentium_gray-text flex items-center gap-1.5 list-none -ml-4">
                        <fa-icon [icon]="bullet.icon" size="xs" class="text-momentum-deep_purple flex-shrink-0"></fa-icon>
                        <span [innerHTML]="bullet.text"></span>
                      </li>
                    } @else {
                      <li class="text-sm text-agentium_gray-text" [innerHTML]="$any(bullet)"></li>
                    }
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Footer — holds the rounded bottom corners -->
  <div class="flex-shrink-0 rounded-b-xl py-4"></div>
</div>
